var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M392.708,178.2H275.802L384.175,7.533H247.642l-128,256h100.693L119.642,502.467L392.708,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.775,7.533h-34.133l-128,256h34.133L281.775,7.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M350.042,178.2l-204.8,243.2l-34.133,81.067L384.175,178.2H350.042z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.642,511c-1.707,0-3.413,0-4.267-0.853c-3.413-2.56-5.12-6.827-3.413-10.24l95.573-227.84h-87.893 c-2.56,0-5.973-1.707-7.68-4.267s-1.707-5.973,0-8.533l128-256c1.707-2.56,4.267-4.267,7.68-4.267h136.533 c3.413,0,5.973,1.707,7.68,4.267s1.707,5.973,0,8.533l-99.84,157.867h100.693c3.413,0,5.973,1.707,7.68,5.12 c1.707,3.413,0.853,6.827-0.853,9.387L126.468,508.44C124.762,510.147,122.202,511,119.642,511z M133.295,255h87.04 c2.56,0,5.12,1.707,6.827,3.413c1.707,2.56,1.707,5.12,0.853,7.68l-78.507,187.733l225.28-267.093h-98.987 c-3.413,0-5.973-1.707-7.68-4.267s-1.707-5.973,0-8.533L368.815,16.067H252.762L133.295,255z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.fee98d3d02e67819b286abd87a9696d4.svg";
export { ForwardRef as ReactComponent };